
export enum PermissionType {
    AddSlots = 1,
    RemoveSlots,
    EditSlots,
    AddReservations,
    EditReservations,
    Overbook,
    AddToStandByList,
    EditStandByParties,
    BookInNonWebReservableSlots,
    BookInSlotsWithInappropriateSize,
    PageParties,
    SendFreeformPageMessages,
    CancelReservations,
    NoShowReservations,
    RemoveStandByParties,
    ManageTableBlockingRules,
    BookOrSeatAtBlockedTables,
    ChangeRestaurantSettings,
    MoveSeatedParties
  }

export enum ValidationMessageType {
    Error = 0,
    Warning = 1,
    Consent = 2
  }
export class ValidationMessageDTO {
    public Message: string;
    public Type: ValidationMessageType;
  }

export enum OperationResultState {
    Success,
    ValidationErrors,
    ServerException,
    InsufficientPermissions,
    AccessDenied,
    Logout,
    Consent = 6
  }

export class OperationResultDTO {
    public State: OperationResultState;
    public ExceptionMessage: string;
    public ValidationMessages: ValidationMessageDTO[];
    public RequiredPermissions: PermissionType[];
    public MissingPermissions: PermissionType[];
  }

  
export class PayloadOperationResultDTO extends OperationResultDTO {
    public Payload: object;
  }